import React, { FC, useEffect, useState } from 'react';
//redux
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
//components
import SidebarItem from '../SidebarItem';
import { Visibility } from 'components/Visibility';
//assets
import reportIcon from 'img/report-icon.svg';
import sidebarQuoteIcon from 'img/sidebar-quote-icon.svg';
import sidebarItemOpenedIcon from 'img/sidebaritem-opened-icon.svg';
import sidebarItemClosedIcon from 'img/sidebaritem-closed-icon.svg';
import sidebarStarIcon from 'img/sidebar-star-icon.svg'
import DomainSettingService from 'services/domainSetting.service';
import { IBatchRequestResponse } from 'models/Batch';
import { IDomainSetting } from 'models/DomainSetting';
//interfaces
import { EnvironmentTypes } from './interface';

const SidebarContent: FC = () => {

  const _domainSettingService = new DomainSettingService();

  const user = useSelector((state: RootState) => state.user);
  const userRoles = user?.roles?.[0] === 'administrator' && user?.userType !== 'customer';
  const usersAllowedAccessBI = process.env.REACT_APP_USER_ACCESS_BI_PORTAL?.split(",");

  const [showPriorityItemsScreen, setShowPriorityItemsScreen] = useState(false);

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: 'UsersAllowAccessSkusScreen' } },
          { enabled: { eq: true } },
        ],
      })
      .then((result: IBatchRequestResponse<IDomainSetting> | undefined) => {
        if (result?.data && user?.username) {
          const { value } = result?.data?.[0];
          const splitedValue = value?.split(',');
          const userIsAllowed = splitedValue ? splitedValue.includes(user.username) : false;
          
          setShowPriorityItemsScreen(userIsAllowed);
        }
      });
  }, []);
  const environment = process.env.REACT_APP_HOME_URL;
  const enableBiPortal = environment === EnvironmentTypes.prd;

  return (
    <div
      className="d-flex flex-column w-100 max-w-lg-100 flex-1 bg-primary px-0 mt-3"
      data-testid="sidebar-content"
    >
      <SidebarItem icon={sidebarQuoteIcon} title="Cotações" dropdownItemTitle="Grid de Cotações" path={"/cotacoes-dashboard"} iconClosed={sidebarItemClosedIcon} iconOpened={sidebarItemOpenedIcon} />
      <Visibility visible={userRoles}>
        <SidebarItem titleOnly icon={reportIcon} title="Relatórios" path={"/relatorios-portal"} target={"_self"} />
      </Visibility>
      <SidebarItem icon={sidebarQuoteIcon} titleOnly title="Baixa Manual" path={"/baixa-manual"} />
      <Visibility visible={(usersAllowedAccessBI?.includes(user?.username ?? "") && enableBiPortal) ?? false}>
        <SidebarItem icon={reportIcon} titleOnly title="BI Portal" path={"/bi-portal"} />
      </Visibility>
      <Visibility visible={showPriorityItemsScreen}>
        <SidebarItem titleOnly icon={sidebarStarIcon} title="SKU's prioritários" path={"/skus-prioritarios"} target={"_self"} />
      </Visibility>
    </div>
  );
};

export default SidebarContent;